import { RootState } from 'modules'

import { individualProfileState } from './duck'

export const selectIndividualProfile = (
  state: RootState
): individualProfileState => state.individualProfile
